import { render } from "./RecipeForm.vue?vue&type=template&id=2bf595d6"
import script from "./RecipeForm.vue?vue&type=script&lang=js"
export * from "./RecipeForm.vue?vue&type=script&lang=js"

import "./RecipeForm.vue?vue&type=style&index=0&id=2bf595d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__